import { Event } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";


export class ChunkChangeEvent extends Event {
    chunk: Chunk;

    constructor( chunk: Chunk ) {
        super( { eventType: ChunkChangeEvent.getEventType() } );

        this.chunk = chunk;
    }

    static getEventType() {
        return 'chunkChange';
    }

    destroy() {
        this.chunk = null;
        super.destroy();
    }
}